<template>
  <card-prime id="card-prime" v-if="this.configuracoesInteresse.configuracao.tipoMidia != ''">
    <template #content>  
      <div v-if="!exibirMensagemErro" class="card">
        <div class="card-container">      
          <div v-if="exibirVideoImagem" class="block border-round mb-3">
            <div id="banner-inicial" class="flex flex-column card-container green-container shadow-4">
              <iframe
                v-if="configuracoesInteresse.configuracao.tipoMidia == 'VIDEO' && configuracoesInteresse.configuracao.linkVideo != ''"
                class="border-round"
                height="315"
                :src="configuracoesInteresse.configuracao.linkVideo"
                title="Nossa escola"
                frameborder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>              
              <div v-if="configuracoesInteresse.configuracao.tipoMidia == 'IMAGEM'">
                <img 
                  v-if="$isMobile() && configuracoesInteresse.configuracao.imagemMobile != ''"
                  :src="`data:image.jpeg;base64,${configuracoesInteresse.configuracao.imagemMobile}`"
                />
                <img
                  v-else-if="configuracoesInteresse.configuracao.imagemDesktop != ''"
                  :src="`data:image.jpeg;base64,${configuracoesInteresse.configuracao.imagemDesktop}`"
                />
              </div>
            </div>
          </div>
          
          <div class="block border-round mt-5 mb-3">
            <div class="flex flex-column card-container green-container">
              <TituloComponent classTitulo="text-blue-800 flex align-items-center
              justify-content-center h-4rem text-4xl font-bold
              border-round" titulo="Bem-vindo ao processo de Matrícula online!" :exiberLinha="false" />
            </div>
            <div class="card">
              <p></p>
              <div class="border-500 mt-6 mb-6"
                v-if="configuracoesInteresse.configuracao.exibeMensagemBoasVindas"
                v-html="configuracoesInteresse.configuracao.mensagemBoasVindas"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </card-prime>
  <div v-if="!exibirMensagemErro && exibirComponenteInteresse">
    <InteresseCadastroComponent></InteresseCadastroComponent>
  </div>
  <div v-if="exibirMensagemErro">
    <pagina-erro-component origem="FormularioInicial"></pagina-erro-component>
  </div>
</template>

<script>
import TituloComponent from "@/components/comuns/TituloComponent.vue";
import InteresseCadastroComponent from "@/components/InteresseCadastroComponent.vue";
import PaginaErroComponent from "@/components/PaginaErroComponent.vue";
import { useOpcoesStore } from "@/store/opcoes";
import { useConfiguracoesInteresseStore } from "@/store/configuracaoInicial";
import { storeToRefs } from "pinia";
import { useConfiguracoesHttpStore } from "@/store/configuracoesHttp";
import CardPrime from "primevue/card";

export default {
  setup() {
    const configuracoesHttpStore = useConfiguracoesHttpStore();
    const opcoes = useOpcoesStore();
    const storeConfiguracoesInteresse = useConfiguracoesInteresseStore();
    const { configuracoesInteresse, exibirMensagemErro, exibirVideoImagem, exibirComponenteInteresse } = storeToRefs(storeConfiguracoesInteresse);
    const { configuracoesHttp } = storeToRefs(configuracoesHttpStore);
    const obterInformacoes = storeConfiguracoesInteresse.obterInformacoes;
    return {
      opcoes,
      configuracoesInteresse,
      exibirMensagemErro,
      exibirVideoImagem,
      exibirComponenteInteresse,
      obterInformacoes,
      configuracoesHttp,
      configuracoesHttpStore
    };
  },

  name: "FormularioInicial",

  components: {
    InteresseCadastroComponent,
    PaginaErroComponent,
    TituloComponent,
    CardPrime,
  },

  props: ["ns"],

  async created() {
    await this.configuracoesHttpStore.configurarAplicacao(this.ns);    
    await this.configuracoesHttpStore.setup('setup')
    await this.obterInformacoes(this.$isMobile());
    await this.opcoes.opcoesIniciaisInteresse(this.configuracoesInteresse);
  },
};
</script>

<style scoped>
img {
  max-width: 100% !important;
  display: flex;
  justify-content: center;
  margin: auto;
}
</style>